// src/pages/GoogleDriveRedirect.jsx
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getFreshAccessToken } from "../chat/api"; // adjust to your code

const GoogleDriveRedirect = () => {
  const navigate = useNavigate();

  useEffect(() => {
    const handleOAuthCallback = async () => {
      const urlParams = new URLSearchParams(window.location.search);
      const code = urlParams.get("code");

      if (!code) {
        alert("Missing authorization code.");
        return;
      }

      try {
        const token = await getFreshAccessToken();
        await axios.post("http://localhost:8000/api/auth/google-drive/callback/", {
          code,
        }, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });

        alert("✅ Google Drive connected!");
        navigate("/Ocr_Data"); // or wherever you want to go
      } catch (error) {
        console.error("❌ Error linking Google Drive:", error);
        alert("Something went wrong. Please try again.");
      }
    };

    handleOAuthCallback();
  }, []);

  return (
    <div className="p-8 text-center">
      <h2 className="text-xl font-semibold">Connecting to Google Drive...</h2>
    </div>
  );
};

export default GoogleDriveRedirect;
